import React, { useEffect, useState } from 'react'
import './style.scss'
import IPImage from '../../../components/IPImage'
import { BaseComponentWithContextProps, componentWithContext } from '../../../base/customHooks/componentHOC'
import { GetMicrosoftContentApi } from '../services/GetMicrosoftContentApi'
import Swal from 'sweetalert2'
import { IMicrosoft } from '../models/models'
import { useCustomReducer } from '../../../base/customHooks'
import { Keyboard, Mousewheel, Navigation, Pagination } from 'swiper'
import { Swiper, SwiperSlide } from 'swiper/react'
import { css } from '@emotion/css'
import IPModal from '../../../components/IPModal'
import IPButton from '../../../components/IPButton'
import IPSelectBox from '../../../components/IPSelectBox'
import { ISelectOption } from '../../../components/IPSelectBox/IPSelectBox'
import { GetAuthSellerPDFApi } from '../services/GetAuthSellerPDFApi'
import { CheckAuthSellerApi } from '../services/CheckAuthSellerApi'

interface IMicrosoftState {
  microsoftData?: IMicrosoft
}

function Microsoft(props: BaseComponentWithContextProps) {
  const [buttonMicrosoft, setButtonMicrosoft] = useState<string>('')
  const [modalIsOpen, setModalIsOpen] = useState<boolean>(false)
  const [isAuth, setIsAuth] = useState<any>()
  const [selectedDetailImageUrl, setSelectedDetailImageUrl] = useState<string>('')
  const [selectedlink, setSelectedLink] = useState<string>('')

  const [authSellerPdfUrl, setAuthSellerPdfUrl] = useState<string>('')
  const [authSellerName, setAuthSellerName] = useState<string>('')
  const [authSellerLoading, setAuthSellerLoading] = useState<boolean>(false)
  const [brandOptions, setBrandOptions] = useState<ISelectOption[]>([])
  const [selectedBrand, setSelectedBrand] = useState<ISelectOption | null>(null)

  const getInitialState = (): IMicrosoftState => {
    return {}
  }

  const initialState = getInitialState()
  const [state, setState] = useCustomReducer<IMicrosoftState>(initialState)

  useEffect(() => {
    getMicrosoft()
    checkAuth()
  }, [])

  const getMicrosoft = async () => {
    props.showLoading()
    const api = new GetMicrosoftContentApi({})

    try {
      const res: IMicrosoft = await api.getMicrosoftContent()
      setState({ microsoftData: res })
    } catch (err: any) {
      Swal.fire({
        icon: 'error',
        title: err?.description || 'Microsoft içeriği alınırken hata oluştu.',
        showConfirmButton: true,
        allowOutsideClick: false,
      })
    } finally {
      props.hideLoading()
    }
  }

  const checkAuth = async () => {
    const api = new CheckAuthSellerApi({})

    try {
      const isAuthenticated = await api.CheckAuth()
      setIsAuth(isAuthenticated?.length > 0)
      setBrandOptions(
        (isAuthenticated || []).map(brand => ({
          value: brand,
          label: brand,
        }))
      )
    } catch (err: any) {
      Swal.fire({
        icon: 'error',
        title: err?.description || 'Yetki kontrolü sırasında hata oluştu.',
        showConfirmButton: true,
        allowOutsideClick: false,
      })
    }
  }

  const openModal = (link?: string, detailImage?: string) => {
    setSelectedDetailImageUrl(detailImage || '')
    setSelectedLink(link || '')
    setModalIsOpen(true)
  }

  const closeModal = () => {
    setModalIsOpen(false)

    setTimeout(() => {
      setSelectedDetailImageUrl('')
      setSelectedLink('')
    }, 300)
  }

  const normalizePdfUrl = (value: unknown): string => {
    if (!value) return ''

    let url = String(value).trim()

    // Baştaki/sondaki quote karakterlerini temizle
    url = url.replace(/^"+|"+$/g, '')
    url = url.replace(/^'+|'+$/g, '')

    // JSON string gibi geldiyse çöz
    try {
      if (
        (url.startsWith('"') && url.endsWith('"')) ||
        (url.startsWith("'") && url.endsWith("'"))
      ) {
        url = JSON.parse(url)
      }
    } catch {
      // parse edilemezse olduğu gibi devam
    }

    return url.trim()
  }

  const isValidHttpUrl = (value: string): boolean => {
    try {
      const parsed = new URL(value)
      return parsed.protocol === 'http:' || parsed.protocol === 'https:'
    } catch {
      return false
    }
  }

  const authSeller = async (name: string) => {
    if (!selectedBrand) {
      Swal.fire({
        icon: 'warning',
        title: 'Lütfen marka seçiniz.',
        showConfirmButton: true,
        allowOutsideClick: false,
      })
      return
    }

    const req = {
      PazaryeriAdi: name,
      MarkaAdi: selectedBrand.value,
    }

    const api = new GetAuthSellerPDFApi({})

    try {
      setAuthSellerLoading(true)
      setAuthSellerPdfUrl('')
      setAuthSellerName(name)
      const res: any = await api.GetAuthSellerPDFApi(req)

      const cleanedUrl = normalizePdfUrl(res)

      if (!cleanedUrl || cleanedUrl === 'Dosya bulunamadı.') {
        Swal.fire({
          icon: 'error',
          title: 'Yetkili satıcı izin belgesi bulunamadı.',
          showConfirmButton: true,
          allowOutsideClick: false,
        })
        return
      }

      if (!isValidHttpUrl(cleanedUrl)) {
        Swal.fire({
          icon: 'error',
          title: 'Geçersiz PDF adresi döndü.',
          text: cleanedUrl,
          showConfirmButton: true,
          allowOutsideClick: false,
        })
        return
      }

      setAuthSellerPdfUrl(cleanedUrl)
    } catch (err: any) {
      console.error('authSeller error:', err)

      Swal.fire({
        icon: 'error',
        title: err?.description || err?.message || 'Yetkili satıcı PDF alınırken hata oluştu.',
        showConfirmButton: true,
        allowOutsideClick: false,
      })
    } finally {
      setAuthSellerLoading(false)
    }
  }

  return (
    <div className='container current-account'>
      <div className='content col-lg-12 m-auto'>
        <div className='card'>
          {state.microsoftData && (
            <div className='card-body'>
              <Swiper
                cssMode={true}
                navigation={true}
                keyboard={true}
                pagination={{ clickable: true }}
                observer={true}
                observeParents={true}
                modules={[Navigation, Mousewheel, Keyboard, Pagination]}
                className='mySwiper'
                style={{ height: 'auto' }}
              >
                {state.microsoftData.SlideMenu?.map((slide, index) =>
                  slide.Link ? (
                    <SwiperSlide key={index}>
                      <a href={slide.Link} target='_blank' rel='noreferrer'>
                        <IPImage
                          className='banner'
                          style={{ height: '100%', padding: '5px 0 0 0' }}
                          src={slide.Image}
                          alt=''
                        />
                      </a>
                    </SwiperSlide>
                  ) : (
                    <SwiperSlide key={index}>
                      <IPImage
                        className='banner'
                        style={{ height: '100%', padding: '5px 0 0 0' }}
                        src={slide.Image}
                        alt=''
                      />
                    </SwiperSlide>
                  )
                )}

                <SwiperSlide>
                  <a href='/products?brand=MICROSOFT&seller=default' target='_blank' rel='noreferrer'>
                    <IPImage
                      className='banner'
                      style={{ height: '100%', padding: '5px 0 0 0' }}
                      src='/images/Microsoft/Ms_banner.jpg'
                      alt=''
                    />
                  </a>
                </SwiperSlide>
              </Swiper>

              {isAuth && (
                <div className='d-flex flex-column align-items-center justify-content-center text-center mt-5 mb-5'>
                  <h3 className='mb-3'>Yetkili Satıcı İzin Belgesi Oluştur / Görüntüle</h3>

                  <div style={{ width: '250px' }} className='mb-3'>
                    <IPSelectBox
                      isClearable
                      id='brand'
                      name='brand'
                      placeholder='Marka Seçiniz'
                      options={brandOptions}
                      value={selectedBrand}
                      onChangeSingle={option => setSelectedBrand(option)}
                    />
                  </div>

                  <div className='d-flex justify-content-center align-items-center gap-5 mt-2'>
                    <IPButton text='Trendyol' onClick={() => authSeller('Trendyol')} />
                    <IPButton text='Hepsiburada' onClick={() => authSeller('Hepsiburada')} />
                  </div>

                  {authSellerLoading && (
                    <div className='mt-4'>
                      <h5>PDF yükleniyor...</h5>
                    </div>
                  )}

                  {!authSellerLoading && authSellerPdfUrl && (
                    <div className='mt-4 w-100 text-center'>
                      <h5 className='mb-3'>{authSellerName} Yetkili Satıcı İzin Belgesi</h5>

                      <div className='mb-3'>
                        <a
                          href={authSellerPdfUrl}
                          target='_blank'
                          rel='noopener noreferrer'
                          style={{ textDecoration: 'underline', cursor: 'pointer' }}
                        >
                          PDF&apos;i yeni sekmede aç
                        </a>
                      </div>

                      {/* iframe bazı sunucularda X-Frame-Options yüzünden çalışmayabilir */}
                      <div style={{ width: '100%', height: '800px' }}>
                        <iframe
                          src={authSellerPdfUrl}
                          title='Yetkili Satıcı İzin Belgesi'
                          style={{
                            width: '100%',
                            height: '100%',
                            border: '1px solid #ddd',
                            borderRadius: '8px',
                          }}
                        />
                      </div>
                    </div>
                  )}
                </div>
              )}

              <div className='row m-t-10 mb-5'>
                <div className='col d-flex card-mobile-resize justify-content-center'>
                  <div className='room me-5' onClick={() => setButtonMicrosoft('Mc_Kampanya')}>
                    <div className='room-image text-center image-hover'>
                      <IPImage
                        className='Mc_Kampanya Mc_Kampanya-original'
                        src='/images/Microsoft/microsoftkampanyalar.png'
                        alt=''
                      />
                      <IPImage
                        className='Mc_Kampanya Mc_Kampanya-hover'
                        src='/images/Microsoft/microsoftkampanyalar.png'
                        alt=''
                      />
                    </div>
                  </div>

                  <div className='room' onClick={() => setButtonMicrosoft('Mc_Hedef')}>
                    <div className='room image-hover'>
                      <div className='room-image text-center'>
                        <IPImage
                          className='Mc_Hedef Mc_Hedef-original'
                          src='/images/Microsoft/microsoftyazilimhedeftakip.png'
                          alt=''
                        />
                        <IPImage
                          className='Mc_Hedef Mc_Hedef-hover'
                          src='/images/Microsoft/microsoftyazilimhedeftakip.png'
                          alt=''
                        />
                      </div>
                    </div>
                  </div>

                  <div className='room' onClick={() => setButtonMicrosoft('Mc_Proje')}>
                    <div className='room ms-5 text-center image-hover'>
                      <div className='room-image text-center'>
                        <IPImage
                          className='Mc_Proje Mc_Proje-original'
                          src='/images/Microsoft/microsofprojekaydi.png'
                          alt=''
                        />
                        <IPImage
                          className='Mc_Proje Mc_Proje-hover'
                          src='/images/Microsoft/microsofprojekaydi.png'
                          alt=''
                        />
                      </div>
                    </div>
                  </div>

                  <div className='room ms-5' onClick={() => setButtonMicrosoft('Mc_Akademi')}>
                    <div className='room-image text-center image-hover'>
                      <IPImage
                        className='Mc_Akademi Mc_Akademi-original'
                        src='/images/Microsoft/microsofakademi.png'
                        alt=''
                      />
                      <IPImage
                        className='Mc_Akademi Mc_Akademi-hover'
                        src='/images/Microsoft/microsofakademi.png'
                        alt=''
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div className='row'>
                <div className='col-md-12 ms-2 m-t-20'>
                  {buttonMicrosoft === 'Mc_Kampanya' ? (
                    <>
                      <h3 className='text-center'>Microsoft Kampanyalar</h3>
                      <hr />
                      <div className='row'>
                        <div className='card-body'>
                          <div className='row m-t-10'>
                            {state.microsoftData.Campaigns &&
                              state.microsoftData.Campaigns.length > 0 &&
                              state.microsoftData.Campaigns.map((camp, index) => (
                                <div
                                  className='col-12 col-md-6 col-xl-3 card-mobile-resize'
                                  style={{ marginBottom: '10px' }}
                                  key={index}
                                >
                                  <div
                                    className={`d-flex flex-column justify-content-between campaign ${css`
                                      padding: 20px;
                                    `}`}
                                  >
                                    <div
                                      onClick={() => openModal(camp.Link, camp.DetailImage)}
                                      style={{ cursor: 'pointer' }}
                                    >
                                      <IPImage src={camp.Image} alt='' className='campaign' />
                                    </div>
                                  </div>
                                </div>
                              ))}
                          </div>

                          <br />

                          <IPModal
                            show={modalIsOpen}
                            onClose={closeModal}
                            width='auto'
                            maxWidth={952}
                            link={selectedlink}
                            confirmText='Ürünlere Git'
                          >
                            <div className='p-3'>
                              <IPImage
                                src={selectedDetailImageUrl || '/images/products/Resim_yok-01.jpg'}
                                alt='ESD'
                                className='campaign'
                                sizes='(max-width: 952px) 100vw, auto'
                                loading='eager'
                              />
                            </div>
                          </IPModal>
                        </div>
                      </div>
                    </>
                  ) : buttonMicrosoft === 'Mc_Hedef' ? (
                    <>
                      <h3 className='text-center'>Microsoft Yazılım Hedef Takip</h3>
                      <hr />
                      <span className='h5 text-center'>
                        <h5>Microsoft Yazılım için Hedef takibiniz bulunmamaktadır.</h5>
                        <h5>
                          Microsoft Hedef Programı Hakkında Detaylı Bilgi için{' '}
                          <a href='mailto:microsoft@index.com.tr'>microsoft@index.com.tr</a> adresine mail
                          atabilirsiniz.
                        </h5>
                      </span>
                    </>
                  ) : buttonMicrosoft === 'Mc_Proje' ? (
                    <>
                      <h3 className='text-center'>Microsoft Proje Kaydı</h3>
                      <hr />
                      <span className='h5 text-center'>
                        <h5>Kayıt Bulunamadı!</h5>
                      </span>
                    </>
                  ) : buttonMicrosoft === 'Mc_Akademi' ? (
                    <>
                      <h3 className='text-center'>Microsoft Akademi</h3>
                      <hr />
                      <div className='row m-t-20'>
                        {state.microsoftData &&
                          state.microsoftData.Academy &&
                          state.microsoftData.Academy.length > 0 &&
                          state.microsoftData.Academy.map((academy, index) => (
                            <div className='row card-mobile-resize' key={index}>
                              <div
                                className='most-popular-products'
                                style={{
                                  minHeight: '210px',
                                  height: '210px',
                                }}
                              >
                                <div className='room'>
                                  <div className='room-image text-center'>
                                    <table className='MicrosoftAkademi-table'>
                                      <tbody>
                                        <tr>
                                          <td className='academy-column'>
                                            <div className='seed'>
                                              {academy.Link ? (
                                                <a
                                                  href={academy.Link}
                                                  target='_blank'
                                                  rel='noreferrer'
                                                  className='file'
                                                >
                                                  {academy.Image ? (
                                                    <IPImage
                                                      src={academy.Image}
                                                      alt=''
                                                      style={{ width: '180px', minWidth: '180px' }}
                                                    />
                                                  ) : (
                                                    ''
                                                  )}
                                                </a>
                                              ) : academy.Image ? (
                                                <IPImage
                                                  src={academy.Image}
                                                  alt=''
                                                  style={{ width: '180px', minWidth: '180px' }}
                                                />
                                              ) : (
                                                ''
                                              )}
                                              {/* <p style={{ color: 'red', width: '120px' }}>{academy.Name}</p> */}
                                            </div>
                                          </td>
                                          {/* Static Description area  */}
                                          <td className='description-column'>
                                            <div
                                              className='description'
                                              style={{ paddingLeft: '30px', textAlign: 'start' }}
                                            >
                                              {academy.Id === 10 && (
                                                <p style={{ color: 'black', fontSize: '13px' }}>
                                                  Microsoft ExpertZone eğitim portalına kayıt olarak faydalı içerikler
                                                  hakkında bilgi edinebilir, sertifika alabilir, puan ve rozetler
                                                  kazanarak profilinizi zengin hale getirebilirsiniz.
                                                  <br />
                                                  Microsoft ExpertZone hakkında daha detaylı bilgi için{' '}
                                                  <a
                                                    href='https://expertzone.microsoft.com'
                                                    target='_blank'
                                                    rel='noreferrer'
                                                    style={{ color: 'black', fontWeight: 'bold' }}
                                                  >
                                                    Tıklayınız!
                                                  </a>
                                                </p>
                                              )}
                                              {academy.Id === 12 && (
                                                <p style={{ color: 'black', fontSize: '13px' }}>
                                                  Elektronik Lisansı tercih ettiğiniz için teşekkür ederiz!
                                                  <br />
                                                  ESD Kurulum aşamasına geçmeden önce yapmanız gerekenleri öğrenmek için{' '}
                                                  <a
                                                    href='\assetWeb\docs\ESDKurulumKilavuzu.pdf'
                                                    target='_blank'
                                                    style={{ color: 'black', fontWeight: 'bold' }}
                                                  >
                                                    Tıklayınız!
                                                  </a>
                                                </p>
                                              )}
                                              {academy.Id === 13 && (
                                                <p style={{ color: 'black', fontSize: '13px' }}>
                                                  Daha iyi işbirliği ve üretkenlik için Office 21 güncellendi! Microsoft
                                                  365 Business Apps, Microsoft 365 Business Basic, Microsoft 365
                                                  Business Standard ve Microsoft 365 Business Premium hakkında detaylı
                                                  bilgiler için{' '}
                                                  <a
                                                    href='\assetWeb\docs\Office_2021.pdf'
                                                    target='_blank'
                                                    style={{ color: 'black', fontWeight: 'bold' }}
                                                  >
                                                    Tıklayınız!
                                                  </a>
                                                </p>
                                              )}
                                              {academy.Id === 18 && (
                                                <p style={{ color: 'black', fontSize: '13px' }}>
                                                  Microsoft, dünyadaki tüm kullanıcıların ve organizasyonların daha
                                                  fazlasını başarabilmesini sağlamak ve onları güçlü kılmak adına
                                                  geçmişte olduğu gibi bugün ve yarın da yanınızdadır!
                                                  <br />
                                                  Microsoft Ürünleri hakkında daha detaylı bilgi için{' '}
                                                  <a
                                                    href='/assetWeb/docs/microsoftMektup.pdf'
                                                    target='_blank'
                                                    style={{ color: 'black', fontWeight: 'bold' }}
                                                  >
                                                    Tıklayınız!
                                                  </a>
                                                </p>
                                              )}
                                              {academy.Id === 14 && (
                                                <p style={{ color: 'black', fontSize: '13px' }}>
                                                  Bu bölümde temel lisanslamalar nelerdir ve neden orijinal yazılım
                                                  tercih etmeniz gerektiğine dair bilgilere ulaşabilirsiniz.
                                                  <br />
                                                  Detaylar için{' '}
                                                  <a
                                                    href='/assetWeb\docs\TemelLisanslamaveOrijinalYazilim.pdf'
                                                    target='_blank'
                                                    style={{ color: 'black', fontWeight: 'bold' }}
                                                  >
                                                    Tıklayınız!
                                                  </a>
                                                </p>
                                              )}
                                              {academy.Id === 15 && (
                                                <p style={{ color: 'black', fontSize: '13px' }}>
                                                  Bu bölümde Windows 11 Ticari İşletmeler için Hibrit Çalışma Alanı
                                                  Çözümleri ile Üretkenliği, İşbirliğini, tutarlılığı, güvenliği ön
                                                  planda tutmayı amaçlarken, aynı zamanda Tüketici için Sadelik,
                                                  Bağlantıda Kalma, İçerik Zenginliği, Oyun platformlarına ulaşım
                                                  kolaylığı sağlar.
                                                  <br />
                                                  Detaylar için{' '}
                                                  <a
                                                    href='\assetWeb\docs\Windows11.pdf'
                                                    target='_blank'
                                                    style={{ color: 'black', fontWeight: 'bold' }}
                                                  >
                                                    Tıklayınız!
                                                  </a>
                                                </p>
                                              )}
                                              {academy.Id === 11 && (
                                                <p style={{ color: 'black', fontSize: '13px' }}>
                                                  Bu bölümde Neden OEM Windows Server 2022 tercih etmeniz gerektiğine
                                                  dair bilgilere ulaşabilirsiniz.
                                                  <br />
                                                  Detaylar için{' '}
                                                  <a
                                                    href='https://www.indexgruppazar.com/content/documents/DppDoc/Server2022-pdf.pdf'
                                                    target='_blank'
                                                    rel='noreferrer'
                                                    style={{ color: 'black', fontWeight: 'bold' }}
                                                  >
                                                    Tıklayınız!
                                                  </a>
                                                </p>
                                              )}
                                              {academy.Id === 16 && (
                                                <p style={{ color: 'black', fontSize: '13px' }}>
                                                  Windows 11 belirtimlerini, özelliklerini ve bilgisayar
                                                  gereksinimlerini incelemek için{' '}
                                                  <a
                                                    href='https://www.microsoft.com/tr-tr/windows/windows-11-specifications#table1'
                                                    target='_blank'
                                                    rel='noreferrer'
                                                    style={{ color: 'black', fontWeight: 'bold' }}
                                                  >
                                                    Tıklayınız!
                                                  </a>
                                                </p>
                                              )}
                                            </div>
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </div>
                                </div>
                              </div>
                            </div>
                          ))}
                      </div>
                    </>
                  ) : (
                    ''
                  )}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}
export default componentWithContext(Microsoft)